<template>
  <div>
    <div
      class="language-wrapper"
      @mouseenter="togglePanel(true)"
      @mouseleave="togglePanel(false)"
      :style="{ height: '60px' }"
    >
      <div class="languagebg" :class="{ dark: isDark }">
        <img
          class="language-img"
          :src="isDark ? languageDarkImg : languageImg"
        />
        <div
          class="selectedLanguage"
          :class="{ dark: isDark, hint: showPanel }"
        >
          {{ currentLanguageTitle }}
          <div v-if="showPanel" class="language-panel">
            <div
              class="languagein"
              v-for="language in languages"
              :key="language.lang"
              @click="changeLanguage(language)"
            >
              {{ language.title }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["isFirst"],
  data() {
    return {
      showPanel: false,
      currentLanguage: this.$i18n.locale,
      // buttonText: this.$i18n.locale,
      languages: [
        { title: "简体中文", lang: "zh" },
        { title: "English", lang: "en" },
      ],
      languageImg: require(`../assets/language.png`),
      languageDarkImg: require(`../assets/language_light.png`),
    };
  },
  computed: {
    currentLanguageTitle() {
      const language = this.languages.find(
        (lang) => lang.lang === this.currentLanguage
      );
      return language ? language.title : "";
    },
  },
  methods: {
    togglePanel(bool) {
      this.showPanel = bool;
    },
    changeLanguage(language) {
      // this.$emit('changeLanguage',lang)
      this.currentLanguage = language.lang;
      // this.buttonText = language.title;
      this.showPanel = false;
      this.$i18n.locale = language.lang;
    },
  },
};
</script>

<style lang="scss" scoped>
.selectedLanguage {
  position: relative;
  color: #101010;
  font-size: 0.15rem;
  height: 60px;
  min-width: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  &:hover {
    color: #2980fe;
  }
  &.dark {
    color: #fff;
    &:hover {
      color: #2980fe;
    }
  }
}
.languagebg {
  display: flex;
  align-items: center;
  height: 30px;
  border-radius: 15px;
  &.dark {
    // background: #38547d;
  }
}
.hint {
  color: #2980fe;
}
.language-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
  margin-left: 20px;
  .language-img {
    margin-right: 6px;
    width: 0.24rem;
    height: 0.24rem;
  }
}
.language-panel {
  position: absolute;
  z-index: 999;
  min-width: 96px;
  top: 50px;
  left: 50%;
  transform: translateX(-50%);
  padding: 12px;
  background: var(--language-bg);
  transition: all 0.3s linear;
  z-index: 10;
  border: 1px solid var(--language-border);
  border-radius: 8px;
  box-shadow: 0 6px 16px 0 rgba(45, 54, 86, 0.05);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px 0;
  .languagein {
    position: relative;
    height: 20px;
    line-height: 20px;
    color: var(--language-color);
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    &:hover {
      color: #2980fe;
    }
  }

  @media screen and (max-width: 767px) {
    .language-img {
      margin-right: 10px;
      width: 0.4rem;
      height: 0.4rem;
    }
  }
}
</style>
